import { ReactComponent as Close } from "asset/mobile/alertClose_m.svg";
import { ReactComponent as BellIconD } from "asset/mobile/bellIcon_d_m.svg";
import { ReactComponent as BellIcon } from "asset/mobile/bellIcon_m.svg";
import { ReactComponent as CancelIconD } from "asset/mobile/cancelIcon_d_m.svg";
import { ReactComponent as CancelIcon } from "asset/mobile/cancelIcon_m.svg";
import { ReactComponent as EditIconD } from "asset/mobile/editIcon_d_m.svg";
import { ReactComponent as EditIcon } from "asset/mobile/editIcon_m.svg";
import { ReactComponent as MailIconD } from "asset/mobile/mailIcon_d_m.svg";
import { ReactComponent as MailIcon } from "asset/mobile/mailIcon_m.svg";
import style from "css/mobile/menu.module.css";
import { useEffect, useState } from "react";
import AlertCardCircle from './alarmCardCircle';
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
// import moment from "moment";
import moment from "moment-timezone";

function AlarmCard({ data, removeAlarm }) {
    const { t, i18n } = useTranslation();
    const deactivatedFontColor = "#090a08";
    const deactivedCircleColor = "#d9d9d9";

    const [circleColor, setCircleColor] = useState("#fff");
    const [fontColor, setFontColor] = useState("#fff");
    const [circleIcon, setCircleIcon] = useState(null);

    const [cardType, setCardType] = useState(null);
    const [cardStatus, setCardStatus] = useState(null);
    const [cardTitle, setCardTitle] = useState(null);
    const [cardDetail, setCardDetail] = useState(null);

    function formatDateTime(startdatetime, enddatetime) {
        return i18n.language === 'en-US' ?
            dayjs(startdatetime)
                .locale("en")
                .format("MMMM DD, YYYY(ddd) HH:mm ~ ")
            + dayjs(enddatetime).locale("en").format("HH:mm")
            : dayjs(startdatetime)
                .locale("ko")
                .format("YYYY년 MM월 DD일 (dd) HH:mm ~ ")
            + dayjs(enddatetime).locale("ko").format("HH:mm");
    }

    function isLastWeek(dateString) {
        const inputDate = new Date(dateString);
        const today = new Date();

        // 현재 날짜 기준으로 이번 주의 시작과 지난 주의 시작 & 끝 계산
        const currentWeekStart = new Date(today);
        currentWeekStart.setDate(today.getDate() - today.getDay()); // 이번 주 일요일(기준점)

        const lastWeekStart = new Date(currentWeekStart);
        lastWeekStart.setDate(currentWeekStart.getDate() - 7); // 지난주 시작 (일요일)

        const lastWeekEnd = new Date(lastWeekStart);
        lastWeekEnd.setDate(lastWeekStart.getDate() + 6); // 지난주 끝 (토요일)

        // 입력된 날짜가 지난주 범위에 있는지 확인
        return inputDate >= lastWeekStart && inputDate <= lastWeekEnd;
    }

    const DIFFDATE = (date) => {
        let nowTime = moment(new Date());
        // let dateTime = moment(new Date(DateTime.fromISO(date, { zone: "utc" }).setZone("Asia/Seoul").toFormat("yyyy-MM-dd HH:mm:ss")));
        let dateTime = moment.utc(date).tz("Asia/Seoul");

        let diff = {
            month: moment.duration(nowTime.diff(dateTime)).months(),
            day: moment.duration(nowTime.diff(dateTime)).days(),
            hour: moment.duration(nowTime.diff(dateTime)).hours(),
            minute: moment.duration(nowTime.diff(dateTime)).minutes(),
        };

        if (diff.day < 1) {
            if (diff.hour < 1) {
                if (diff.minute < 1) {
                    return <div>{t("ALARM.STATUS.JUST_NOW")}</div>;
                } else {
                    // return <div>{diff.minute} 분 전</div>;
                    return <div>{t("ALARM.STATUS.MIN_BEFORE", { MIN: diff.minute })}</div>;
                }
            } else {
                return (
                    <div>
                        {/* {diff.hour}시간 {diff.minute}분 전 */}
                        {t("ALARM.STATUS.HOUR_MIN_BEFORE", { HOUR: diff.hour, MIN: diff.minute })}
                    </div>
                );
            }
        } else {
            return <div>
                {(isLastWeek(date) ? t("ALARM.STATUS.LAST_WEEK") : "")
                    + (i18n.language === "en-US"
                        ? dayjs(date).locale("en").format("dddd")
                        : dayjs(date).locale("ko").format("dddd"))}
            </div>;
        }
    };

    const changedLangConvert = (changedStr) => {
        if (i18n.language === 'ko_KR') {
            return changedStr;
        } else if (i18n.language === 'en-US') {
            let tmp = changedStr.split(",");
            for (let i = 0; i < tmp.length; i++) {
                tmp[i] = t("CHANGED." + tmp[i]);
            }

            return tmp.join(", ");
        }
    }

    useEffect(() => {
        const isActive = data.READ_YN === "N";
        setCardStatus(DIFFDATE(data.INPUT_DT));
        setCardTitle(data.TITLE);

        switch (data.ALRAM_TYPE) {
            case "CD1301":   // Notification
                setCardDetail(formatDateTime(data.START_DATETIME, data.END_DATETIME));
                if (isActive) {
                    setFontColor("#3392eb");
                    setCircleColor("#ddf0f8");
                    setCircleIcon(<MailIcon />);
                } else {
                    setFontColor(deactivatedFontColor);
                    setCircleColor(deactivedCircleColor);
                    setCircleIcon(<MailIconD />);
                }
                setCardType(t("ALARM.LABEL.MEETING_INVITATION"));
                break;
            case "CD1302":   // Modification
                setCardDetail(t("ALARM.MESSAGE.SCHEDULE_CHANGED", { CONTENT: changedLangConvert(data.CONTENTS) }));
                if (isActive) {
                    setFontColor("#fd9800");
                    setCircleColor("#fff4e3");
                    setCircleIcon(<EditIcon />);
                } else {
                    setFontColor(deactivatedFontColor);
                    setCircleColor(deactivedCircleColor);
                    setCircleIcon(<EditIconD />);
                }
                setCardType(t("ALARM.LABEL.SCHEDULE_CHANGED"));
                break;
            case "CD1303":   // Cancellation
                setCardDetail(formatDateTime(data.START_DATETIME, data.END_DATETIME));
                if (isActive) {
                    setFontColor("#ff7467");
                    setCircleColor("#fff0ee");
                    setCircleIcon(<CancelIcon />);
                } else {
                    setFontColor(deactivatedFontColor);
                    setCircleColor(deactivedCircleColor);
                    setCircleIcon(<CancelIconD />);
                }
                setCardType(t("ALARM.LABEL.SCHEDULE_CANCELED"));
                break;
            case "CD1304":   // Invitation
                if (isActive) {
                    setFontColor("#1cb691");
                    setCircleColor("#e1f6f1");
                    setCircleIcon(<BellIcon />);
                } else {
                    setFontColor(deactivatedFontColor);
                    setCircleColor(deactivedCircleColor);
                    setCircleIcon(<BellIconD />);
                }
                setCardType(t("ALARM.STATUS.5MIN_BEFORE_MEETING"));
                break;
            default:
                setFontColor("#fff");
                setCircleColor("#fff");
                setCircleIcon(null);
        }
    }, [data])

    // 카드 swipe right 해서 해당 카드 알람 삭제 (mobile)
    useEffect(() => {
        // DOM이 업데이트될 때까지 기다림
        const card = document.querySelector(".swipe-area-" + data.ALRAM_NUM);

        const pStart = { x: 0, y: 0 };
        const pCurrent = { x: 0, y: 0 };
        let alarmNum = null;
        let changeX = null;
        const actionTriggerLength = 150;

        function deleteData() {
            removeAlarm(alarmNum);
        }

        function swipeStart(e) {
            alarmNum = data.ALRAM_NUM;
            let touch = e.targetTouches ? e.targetTouches[0] : e;
            pStart.x = touch.screenX;
            pStart.y = touch.screenY;
        }

        function swipeEnd(e) {
            if (changeX < actionTriggerLength) {
                card.style.transform = `translateX(0px)`;
            } else {
                card.style.transform = `translateX(100%)`;
                deleteData();
            }
        }

        function swipe(e) {
            let touch = e.changedTouches ? e.changedTouches[0] : e;
            pCurrent.x = touch.screenX;
            pCurrent.y = touch.screenY;

            changeX = Math.max(0, pCurrent.x - pStart.x);
            card.style.transform = `translateX(${changeX}px)`
        }

        card.addEventListener("touchstart", swipeStart, false);
        card.addEventListener("touchmove", swipe, false);
        // iPhone에 기본 내려서 새로고침 막기
        // document.addEventListener("touchmove", (event) => { if (window.scrollY === 0) event.preventDefault() }, { passive: false });
        card.addEventListener("touchend", swipeEnd, false);

        return () => {
            card.removeEventListener("touchstart", swipeStart);
            card.removeEventListener("touchmove", swipe);
            card.removeEventListener("touchend", swipeEnd);
        }
        // }
    }, []);
    return (
        <div className={style.card_container}>
            <div className={style.card_wrapper + " swipe-area-" + data.ALRAM_NUM}>
                <AlertCardCircle circleColor={`${circleColor}`} icon={circleIcon} />
                <div className={style.card_content}>
                    <div className={style.card_header} style={{ color: `${fontColor}` }}>
                        <div className={style.card_type}>{cardType}</div>
                        <div className={style.card_status}>{cardStatus}</div>
                    </div>
                    <div className={style.card_title}>[{cardTitle}]</div>
                    <div className={style.card_detail}>{cardDetail}</div>
                </div>
                <button className={style.close_btn}>
                    <Close onClick={() => removeAlarm(data.ALRAM_NUM)} />
                </button>
            </div>
        </div>
    )
}

export default AlarmCard
